import React from 'react'
import { CAUSAL_TOOLTIP } from '../../config/settings/constant'
import { Typography } from '@chilecompra/react-kit/components'
import { ExclamationIcon, Tooltip, TooltipContainer, TooltipIcon } from './AbilityStatusSection.styles'

/**
 * The icon with tooltip component
 **/
const IconWithTooltip = () => {
  return (
    <TooltipContainer>
      <Tooltip
        content={
          <Typography color="white" variant="subtitle1">
            {CAUSAL_TOOLTIP}
          </Typography>
        }
      >
        <TooltipIcon>
          <ExclamationIcon padding="2px 10px 0 22px" />
        </TooltipIcon>
      </Tooltip>
    </TooltipContainer>
  )
}

export default IconWithTooltip
